import { render } from "./TheRfidContainer.vue?vue&type=template&id=6c26ab3b"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__